<template>
  <v-container fluid class="ma-0 pa-0 mb-4">
    <v-row>
      <template v-if="isBusena">
        <v-col cols="12" md="12">
          <el-switch
            class="mb-0"
            :classP="showBusena ? 'strong-label' : ''"
            label="Būsenų istorija"
            v-model="showBusena"
          />
        </v-col>
        <v-col cols="12" md="12" class="mb-4" v-if="showBusena">
          <istorija-busena />
        </v-col>
      </template>
      <template v-if="isDuomenys">
        <v-col cols="12" md="12">
          <el-switch
            class="mb-0"
            :classP="showDuomenys ? 'strong-label' : ''"
            label="Duomenų istorija"
            v-model="showDuomenys"
          />
        </v-col>
        <v-col cols="12" md="12" class="mb-4" v-if="showDuomenys">
          <istorija-duomenys :duomenys="duomenys" />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../../mixins/userRole'
import busena from '../../../mixins/busena'
import IstorijaBusena from './IstorijaBusena'
import IstorijaDuomenys from './IstorijaDuomenys'

export default {
  name: 'HipotekaIstorija',
  components: {
    IstorijaBusena,
    IstorijaDuomenys,
  },
  mixins: [userRole, busena],
  props: {
    busena: Boolean,
    duomenys: String,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      showBusena: false,
      showDuomenys: false,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas']),
    isBusena() {
      return this.busena && false
    },
    isDuomenys() {
      return (
        this.duomenys &&
        !this.isRengiamas &&
        !this.isGrazintas &&
        this.roleRG &&
        false
      )
    },
  },
  created() {},
  methods: {
    //
  },
}
</script>
